// extracted by mini-css-extract-plugin
module.exports = {"Forbidden":"Forbidden_Forbidden__1VcBm","Message":"Forbidden_Message__zqg_S"};